'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextInput = require('../TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'wrapper': 'ccl-6077f8f44633e37e',
  'map': 'ccl-d24dd57ad56b5dad',
  'input': 'ccl-13e193ededc52ec8'
};

/**
 * A Location Map for customers to identify their location using Google Maps.
 */

var LocationMap = function (_Component) {
  _inherits(LocationMap, _Component);

  function LocationMap() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocationMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocationMap.__proto__ || Object.getPrototypeOf(LocationMap)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      var _this$props = _this.props,
          loadGoogleMapsApi = _this$props.loadGoogleMapsApi,
          googleApiKey = _this$props.googleApiKey,
          coords = _this$props.coords,
          onMapMarkerChange = _this$props.onMapMarkerChange;


      loadGoogleMapsApi({ googleApiKey: googleApiKey }).then(function () {
        var mapOptions = {
          center: coords,
          streetViewControl: false,
          overviewMapControl: false,
          mapTypeControl: false,
          mapTypeId: 'roadmap',
          zoom: 16
        };

        _this.map = new window.google.maps.Map(_this.mapElement, mapOptions);

        var mapMarkerOptions = {
          map: _this.map,
          draggable: true,
          position: coords
        };

        _this.mapMarker = new window.google.maps.Marker(mapMarkerOptions);
        _this.mapMarker.addListener('dragend', onMapMarkerChange(_this.map));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocationMap, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          formattedAddress = _props.formattedAddress;

      return _react2.default.createElement(
        'div',
        { className: styles.wrapper },
        _react2.default.createElement(
          'div',
          { className: styles.input },
          _react2.default.createElement(_TextInput2.default, {
            label: label,
            id: 'location-map',
            name: 'location-map',
            value: formattedAddress,
            disabled: true
          })
        ),
        _react2.default.createElement('div', {
          className: styles.map,
          ref: function ref(element) {
            _this2.mapElement = element;
          }
        })
      );
    }
  }]);

  return LocationMap;
}(_react.Component);

LocationMap.displayName = 'LocationMap';
exports.default = LocationMap;


LocationMap.propTypes = {
  /**
   * Loader function for the Google Maps API. Should return a promise for when
   * the API has finished loading `window.google.maps`.
   */
  loadGoogleMapsApi: _propTypes2.default.func.isRequired,

  /**
   * Google Maps API key
   */
  googleApiKey: _propTypes2.default.string.isRequired,

  /**
   * Initial coordinates for the centre of the map.
   */
  coords: _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lng: _propTypes2.default.number
  }),

  /**
   * Event handler for whenever the map marker changes position.
   */
  onMapMarkerChange: _propTypes2.default.func.isRequired,

  /**
   * Label for the text input showing the customer’s current location
   */
  label: _propTypes2.default.string.isRequired,

  /**
   * Formatted address for the customer’s location.
   */
  formattedAddress: _propTypes2.default.string.isRequired
};

LocationMap.defaultProps = {
  /**
   * If the LocationMap is invoked *without* coords for any reason, fall back to
   * centering on The River Building rather than rendering a broken map.
   */
  coords: {
    lat: 51.510129,
    lng: -0.091105
  }
};